import { View, SwitchButtonView } from 'ckeditor5';

/*
 * The equation dialog's content: a host for MathLive's <math-field>, a
 * "Show on its own line" switch and a status line. Exposed as separate views
 * (`views`) so the dialog's focus cycler can reach the field and the switch.
 */

class FieldHostView extends View {
    constructor(locale) {
        super(locale);
        this.field = null;
        this.setTemplate({ tag: 'div', attributes: { class: ['ck-math-form__field'] } });
    }

    setField(field) {
        this.field = field;
        this.element.appendChild(field);
    }

    focus() {
        if (this.field) this.field.focus();
    }
}

export default class MathFormView extends View {
    constructor(locale) {
        super(locale);
        const t = locale.t;
        const bind = this.bindTemplate;

        this.set('isBlock', false);
        this.set('status', '');

        this.fieldView = new FieldHostView(locale);

        this.displaySwitch = new SwitchButtonView(locale);
        this.displaySwitch.set({ label: t('Show on its own line'), withText: true });
        this.displaySwitch.class = 'ck-math-form__display';
        this.displaySwitch.bind('isOn').to(this, 'isBlock');
        this.displaySwitch.on('execute', () => {
            this.isBlock = !this.isBlock;
        });

        this.statusView = new View(locale);
        this.statusView.setTemplate({
            tag: 'div',
            attributes: {
                class: ['ck-math-form__status', bind.if('status', 'ck-hidden', (status) => !status)],
                'aria-live': 'polite',
            },
            children: [{ text: bind.to('status') }],
        });

        /** The dialog's content views, in order. */
        this.views = [this.fieldView, this.displaySwitch, this.statusView];
    }

    /** @param {HTMLElement} field a MathfieldElement */
    setField(field) {
        this.fieldView.setField(field);
    }

    get field() {
        return this.fieldView.field;
    }

    focus() {
        if (this.field) this.fieldView.focus();
        else this.displaySwitch.focus();
    }
}
